import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { validateToken } from "@/utils/helper";

export default function Home() {
  const token = localStorage.getItem("token");

  let isTokenValid = false;

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      isTokenValid = validateToken(token);
    }

    if (isTokenValid) {
      navigate("/home", { replace: true });
    } else {
      localStorage.removeItem("userId");
      localStorage.removeItem("role");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return null;
}
